export default __webpack_public_path__ + "static/media/fruit14.fffe82e0.jpg";